import ImageAtom from "../../Atoms/ImageAtom";
import TypographyMontserrat from "../../Atoms/TypographyMontserrat";

import NewPrimaryButton from "../../Atoms/Buttons/NewPrimaryButton";
import {
    GRID,
    DETAIL_CONTAINER,
    IMAGE_CONATINER,
    HEADING,
    IMAGE_STYLES,
    LIST,
    LIST_ICON,
    LIST_TEXT,
    BTN,
} from "./constants";
import { WARDROBE_STYLING_ENDPOINT } from "../../../public/Constants/EnumConstants";

const NothingToWearSection = ({ data }) => {
    return (
        <div className={GRID}>
            <div className={DETAIL_CONTAINER}>
                <TypographyMontserrat
                    align="left"
                    text={data?.primary?.heading}
                    customStyle={HEADING}
                />

                {data?.primary?.bulletlist.map((item, index) => {
                    return (
                        <div key={index} className={LIST}>
                            <ImageAtom
                                style={LIST_ICON}
                                image={item?.liststyle}
                            />
                            <TypographyMontserrat
                                align="left"
                                text={item?.description}
                                customStyle={LIST_TEXT}
                            />
                        </div>
                    );
                })}

                <NewPrimaryButton
                    className={BTN}
                    text={data?.primary?.buttontext}
                    href={WARDROBE_STYLING_ENDPOINT}
                />
            </div>

            <div className={IMAGE_CONATINER}>
                <ImageAtom style={IMAGE_STYLES} image={data?.primary?.banner} />
            </div>
        </div>
    );
};

export default NothingToWearSection;
